import React, { useEffect } from "react";
import Allmutton from "../Mutton/Allmutton";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
const MuttonM = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Header />
      <Allmutton />
      <Footer />
    </>
  );
};

export default MuttonM;
